
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/referencni-videa/[nanoid]",
      function () {
        return require("private-next-pages/referencni-videa/[nanoid].js");
      }
    ]);
  